import PopupCreatePaymentLink from './PopupCreatePaymentLink';

export default PopupCreatePaymentLink;
